import React from 'react';
import { Sparkles, Monitor, Tv, Eye } from 'lucide-react';

export const QUALITY_OPTIONS = [
  { id: '720p', label: '720p HD', sub: 'Rápido / Liviano', res: '1280x720' },
  { id: '1080p', label: '1080p FHD', sub: 'Estándar YouTube/Reels', res: '1920x1080', recommended: true },
  { id: '4k', label: '4K Ultra', sub: 'Máxima Calidad', res: '3840x2160' }
];

export function QualitySelector({
  quality = '1080p',
  onSelectQuality
}) {
  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
        <label style={{
          fontSize: '11px',
          fontWeight: 700,
          textTransform: 'uppercase',
          letterSpacing: '0.6px',
          color: '#94a3b8',
          display: 'flex',
          alignItems: 'center',
          gap: '5px'
        }}>
          <Monitor size={12} color="#c084fc" /> Calidad de Renderizado
        </label>
        <span style={{ fontSize: '10px', color: '#a855f7', fontWeight: 600 }}>
          {quality === '1080p' ? '1080p Full HD (Recomendado)' : quality === '4k' ? '4K Ultra HD' : '720p HD Rápido'}
        </span>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '8px' }}>
        {QUALITY_OPTIONS.map((opt) => {
          const isSelected = quality === opt.id;
          return (
            <button
              key={opt.id}
              type="button"
              onClick={() => onSelectQuality(opt.id)}
              style={{
                padding: '8px 4px',
                borderRadius: '8px',
                fontSize: '11px',
                fontWeight: 600,
                cursor: 'pointer',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                background: isSelected ? 'rgba(168, 85, 247, 0.16)' : '#141724',
                color: isSelected ? '#c084fc' : '#94a3b8',
                border: isSelected ? '1px solid rgba(192, 132, 252, 0.6)' : '1px solid rgba(255,255,255,0.06)',
                transition: 'all 0.15s ease',
                position: 'relative'
              }}
            >
              <span style={{ fontWeight: 700 }}>{opt.label}</span>
              <span style={{ fontSize: '9px', color: isSelected ? '#e9d5ff' : '#64748b' }}>{opt.sub}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
